<template>
  <span :style="{'color':color}">
    <FeatherIcon
      :icon="featherIcon"
      :size="size"
    />
  </span>
</template>

<script>
export default {
  name: 'MediaTypeIcon',
  props: {
    icon: {
      type: String,
      default: 'fb',
    },
    size: {
      type: String,
      default: '30',
    },
  },
  computed: {
    featherIcon() {
      return this.icon === 'fb' ? 'FacebookIcon' : 'InstagramIcon'
    },
    color() {
      return this.icon === 'fb' ? '#1AB7EA' : '#FF369E'
    },
  },
}
</script>
